const languageMapper = Object.freeze({
  de: 'de_DE',
  en: 'en_GB',
  pl: 'pl_PL',
});

const commercetoolsLanguageMapper = {
  de: 'de-DE',
  en: 'en-GB',
  pl: 'pl-PL',
};

const mapLanguage = (lang) => {
  if (!languageMapper[lang]) {
    console.error(`Language mapper is missing language ${lang}`);
  }

  //If language is not defined in languageMapper then select first locale
  return languageMapper[lang] || languageMapper[Object.keys(languageMapper)[0]];
};

module.exports = {
  languageMapper,
  commercetoolsLanguageMapper,
  mapLanguage
};
